export const environment = {
  production: true,
  apiUrl: '/api',
  geoserver: 'https://geo.smartreport.cl/geoserver/tu/wms?'
};
